<ng-container *ngIf="progressReport.length || dprProgress.comment">
  <table class="layout-fixed striped">
    <colgroup>
      <col class="width-20" />
      <col class="width-12" />
      <col class="width-12" />
      <col class="width-12" />
      <col class="width-12" />
      <col class="width-12" />
      <col class="width-20" />
    </colgroup>
    <thead>
      <tr>
        <th colspan="7">
          <h3>{{subprojectConfiguration.customNames.progressTabName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="progressReport.length">
      <tbody class="secondary-header">
        <tr>
          <td>{{progressTerminology.block}}</td>
          <td class="text-center">{{progressTerminology.clearedToday}}</td>
          <td class="text-center">{{progressTerminology.clearedTotal}}</td>
          <td class="text-center">{{progressTerminology.percentComplete}}</td>
          <td class="text-center">{{progressTerminology.targetTotal}}</td>
          <td class="text-center">{{progressTerminology.totalLeft}}</td>
          <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
        </tr>
      </tbody>
    </ng-container>
    <tbody>
      <tr *ngFor="let progress of progressReport">
        <td class="accent">{{progress.name}}</td>
        <td class="text-center">{{progress.clearedToday}}</td>
        <td class="text-center">{{(progress.progressStockDetails.clearedTotal | number: '1.2-2')}}</td>
        <td class="text-center">{{(progress.progressStockDetails.percentComplete | number: '1.2-2')}}</td>
        <td class="text-center">{{progress.targetTotal}}</td>
        <td class="text-center">{{(progress.progressStockDetails.totalLeft| number: '1.2-2')}}</td>
        <td>{{progress.comment}}</td>
      </tr>
    </tbody>
    <tbody class="secondary-header" *ngIf="dprProgress.comment">
      <tr>
        <td colspan="7">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
      </tr>
    </tbody>
    <tbody *ngIf="dprProgress.comment">
      <tr>
        <td colspan="7" class="white-space-pre-wrap" [innerHTML]="(dprProgress.comment | trim) || '-'"></td>
      </tr>
    </tbody>
  </table>
</ng-container>
